import React from 'react'
import pure from 'recompose/pure'
import FaPinterest from 'react-icons/lib/fa/pinterest-p'
import FaTwitter from 'react-icons/lib/fa/twitter'
import IoSocialInstagram from 'react-icons/lib/io/social-instagram'
import FaGooglePlus from 'react-icons/lib/fa/google-plus'
import FaFacebook from 'react-icons/lib/fa/facebook'
import Section from './Section'
import ConnectItem from './ConnectItem'
import goToUrl from 'utils/goToUrl'

const Connect = ({ header }) => {
  const items = [
    { Icon: FaPinterest, url: process.env.PINTEREST_URL, title: 'Pinterest' },
    { Icon: FaFacebook, url: process.env.FACEBOOK_PAGE, title: 'Facebook' },
    { Icon: FaTwitter, url: process.env.TWITTER_URL, title: 'Twitter' },
    {
      Icon: IoSocialInstagram,
      url: process.env.INSTAGRAM_URL,
      title: 'Instagram',
    },
    {
      Icon: FaGooglePlus,
      url: process.env.GOOGLEPLUS_URL,
      title: 'Google Plus',
    },
  ]
  return (
    <Section
      header={header}
      render={() => (
        <div>
          {items.map(({ Icon, url, title }, i) => (
            <ConnectItem
              key={`socialMediaSidebarItem${i}`}
              Icon={Icon}
              url={url}
              title={title}
              onClick={goToUrl(url)}
            />
          ))}
        </div>
      )}
    />
  )
}

export default pure(Connect)



// WEBPACK FOOTER //
// ./src/components/Sidebar/Connect.js